import { Badge, getTierColor } from '@/types/badges';

// Extended motivational quotes library (200+)
export const MOTIVATIONAL_QUOTES = [
  "The only bad workout is the one that didn't happen",
  "Pain is temporary, glory is forever",
  "You don't find willpower, you create it",
  "Champions are made when no one is watching",
  "Your future self will thank you",
  "Discipline is choosing what you want most over what you want now",
  "The body achieves what the mind believes",
  "Every rep counts. Every day matters",
  "Strong is not given. It's earned",
  "Comfort zone? That's where dreams go to die",
  "You're one workout away from a better mood",
  "Legends don't skip days",
  "The iron never lies",
  "Sweat is just fat crying",
  "Be stronger than your excuses",
  "No pain, no gain",
  "Train insane or remain the same",
  "Your only limit is you",
  "Rise and grind",
  "Make yourself proud",
  "Fall down seven times, stand up eight",
  "Winners train, losers complain",
  "Excuses don't burn calories",
  "Dream big, lift bigger",
  "Be the hardest worker in the room",
  "Success starts with self-discipline",
  "Push yourself because no one else will",
  "The pain you feel today is the strength you feel tomorrow",
  "Don't wish for it, work for it",
  "Hustle for that muscle",
  "Respect your body, fuel it well",
  "Sore today, strong tomorrow",
  "The gym is my therapy",
  "Lift heavy, live happy",
  "Suffer now and live the rest of your life as a champion",
  "Every champion was once a contender that refused to give up",
  "The only way to define your limits is by going beyond them",
  "What seems impossible today will be your warm-up tomorrow",
  "Strive for progress, not perfection",
  "Your body can stand almost anything. It's your mind you have to convince",
  "The difference between try and triumph is a little umph",
  "Strength does not come from winning",
  "No one ever drowned in sweat",
  "The clock is ticking. Are you becoming the person you want to be?",
  "Today's pain is tomorrow's power",
  "The last three or four reps is what makes the muscle grow",
  "If it doesn't challenge you, it doesn't change you",
  "Go hard or go home",
  "Believe in yourself and all that you are",
  "The resistance you fight physically in the gym strengthens you mentally",
  "Action is the foundational key to all success",
  "Your health is an investment, not an expense",
  "The only person you should try to be better than is who you were yesterday",
  "When you want to succeed as bad as you want to breathe, you'll be successful",
  "Success is walking from failure to failure with no loss of enthusiasm",
  "A one hour workout is 4% of your day. No excuses",
  "Don't count the days, make the days count",
  "The harder you work, the luckier you get",
  "Motivation is what gets you started. Habit is what keeps you going",
  "You miss 100% of the shots you don't take",
  "It never gets easier, you just get stronger",
  "Blood, sweat, and respect. First two you give, last one you earn",
  "Be patient and tough; someday this pain will be useful to you",
  "The only easy day was yesterday",
  "Train like a beast, look like a beauty",
  "Obsessed is a word the lazy use to describe the dedicated",
  "Strength doesn't come from what you can do. It comes from overcoming the things you once thought you couldn't",
  "You're not going to master the rest of your life in one day. Relax. Master the day. Then just keep doing that every day",
  "Think of your workouts as important meetings you scheduled with yourself",
  "Take care of your body. It's the only place you have to live",
  "Fitness is not about being better than someone else. It's about being better than you used to be",
  "What hurts today makes you stronger tomorrow",
  "The best project you'll ever work on is you",
  "Don't stop when you're tired. Stop when you're done",
  "Once you see results, it becomes an addiction",
  "The only bad workout is the one you didn't do",
  "A year from now you will wish you had started today",
  "Success isn't always about greatness. It's about consistency",
  "I don't count my sit-ups. I only start counting when it starts hurting",
  "Life begins at the end of your comfort zone",
  "The body achieves what the mind believes",
  "We are what we repeatedly do. Excellence then is not an act but a habit",
  "Don't limit your challenges. Challenge your limits",
  "The iron is the best antidepressant I have ever found",
  "Fitness is like marriage. You can't cheat on it and expect it to work",
  "Making excuses burns zero calories per hour",
  "You can have results or excuses. Not both",
  "Strong people are harder to kill than weak people",
  "The pain of discipline is nothing like the pain of disappointment",
  "Crawling is acceptable. Falling is acceptable. Puking is acceptable. Crying is acceptable. Quitting is not",
  "If you're tired of starting over, stop giving up",
  "Your body hears everything your mind says. Stay positive",
  "Champions keep playing until they get it right",
  "The successful warrior is the average person with laser-like focus",
  "You are confined only by the walls you build yourself",
  "Every workout is a brick in the building of a better you",
  "It's not about having time. It's about making time",
  "Fear is what stops you. Courage is what keeps you going",
  "Sweat now, shine later",
  "To be a champion, you have to believe in yourself when nobody else will",
  "Weakness is a choice, so is strength",
  "The will to win means nothing without the will to prepare",
  "Hard work beats talent when talent doesn't work hard",
  "What defines us is how well we rise after falling",
  "Don't wait for opportunity. Create it",
  "The difference between a successful person and others is not lack of strength, not a lack of knowledge, but rather a lack in will",
  "I hated every minute of training, but I said, 'Don't quit. Suffer now and live the rest of your life as a champion'",
  "The pump is the greatest feeling you can get in a gym",
  "I'm not telling you it's going to be easy - I'm telling you it's going to be worth it",
  "No citizen has a right to be an amateur in the matter of physical training",
  "It's supposed to be hard. If it wasn't hard, everyone would do it",
  "Be humble. Be hungry. And always be the hardest worker in the room",
  "Some people want it to happen, some wish it would happen, others make it happen",
  "I train because I know what it's like to feel weak. And I never want to feel that way again",
  "The real workout starts when you want to stop",
  "Your mind gives up before your body ever will",
  "Training gives us an outlet for suppressed energies created by stress and thus tones the spirit just as exercise conditions the body",
  "Suffer the pain of discipline or suffer the pain of regret",
  "Rome wasn't built in a day, but they were laying bricks every hour",
  "You're only one workout away from a good mood",
  "Energy and persistence conquer all things",
  "The more you sweat in training, the less you bleed in combat",
  "Set goals, smash them, repeat",
  "The greatest glory in living lies not in never falling, but in rising every time we fall",
  "Be addicted to bettering yourself",
  "Tough times don't last. Tough people do",
  "The harder the battle, the sweeter the victory",
  "Your legs are not giving out. Your head is giving up",
  "Most people fail, not because of lack of desire, but because of lack of commitment",
  "There are no shortcuts to any place worth going",
  "It's not whether you get knocked down, it's whether you get up",
  "Winners focus on winning. Losers focus on winners",
  "Believe you can and you're halfway there",
  "Don't let what you cannot do interfere with what you can do",
  "Nothing will work unless you do",
  "If you want something you've never had, you must be willing to do something you've never done",
  "The only person you are destined to become is the person you decide to be",
  "Success is not final, failure is not fatal: it is the courage to continue that counts",
  "Every morning you have two choices: continue to sleep with your dreams or wake up and chase them",
  "Strength is the product of struggle",
  "The distance between your dreams and reality is called discipline",
  "Be fearless in the pursuit of what sets your soul on fire",
  "Great things never came from comfort zones",
  "You have to think it before you can do it. The mind is what makes it all possible",
  "Nobody cares about your excuses. Nobody pities you for procrastinating. Nobody is going to coddle you because you are lazy. It's your life, own it",
  "Pain is weakness leaving the body",
  "Conquer from within",
  "Your time is limited. Don't waste it living someone else's life",
  "If it was easy, everyone would do it",
  "The only failure is not trying",
  "Today I will do what others won't, so tomorrow I can do what others can't",
  "Wake up with determination. Go to bed with satisfaction",
  "Impossible is just an opinion",
  "Excellence is not a singular act, but a habit. You are what you repeatedly do",
  "Do something today that your future self will thank you for",
  "The question isn't who is going to let me; it's who is going to stop me",
  "Don't decrease the goal. Increase the effort",
  "If you're not pushing yourself, you're not growing",
  "The only place where success comes before work is in the dictionary",
  "A dream doesn't become reality through magic; it takes sweat, determination and hard work",
  "The starting point of all achievement is desire",
  "You don't get what you wish for. You get what you work for",
  "Stay focused. Stay positive. Stay strong",
  "No matter how slow you go, you're still lapping everyone on the couch",
  "First they'll ask why you're doing it. Later they'll ask how you did it",
  "The pain of today is the victory of tomorrow",
  "Doubt kills more dreams than failure ever will",
  "Results happen over time, not overnight. Work hard, stay consistent, and be patient",
  "Fall in love with taking care of yourself",
  "Stop wishing. Start doing",
  "Eat clean. Train dirty",
  "The grind includes Friday nights and Saturday mornings",
  "Embrace the pain. It's building a stronger you",
  "Your speed doesn't matter. Forward is forward",
  "I don't want to look back and think 'I could have'",
  "The weight on your shoulders will build the muscles to carry it",
  "Focus on where you want to be, not where you are",
  "Trust the process. Your time is coming",
  "Transform your can'ts into cans and your dreams into plans",
  "Motivation gets you started. Dedication keeps you going",
  "Winners don't wait for chances. They take them",
  "A healthy outside starts from the inside",
  "When my body 'shouts' STOP, my mind 'screams' NEVER",
  "Defeat the voice that says 'maybe tomorrow'",
  "Consistency is the key to transformation",
  "Your biggest competition is who you were yesterday",
  "Every workout brings you closer to your goal",
  "The fire inside you burns brighter than the fire around you",
  "Lift like your life depends on it. Because it does",
  "Average lets excuses win. Be exceptional",
  "One more rep. One more set. One step closer",
  "Champions do extra. Champions make sacrifices",
  "Train like an absolute animal today",
  "The grind doesn't stop. Neither should you",
  "They laughed at my goals. Then I achieved them",
  "Be savage, not average",
  "The pain fades. The glory lasts forever",
  "Evolve or repeat",
  "You are built for this",
  "Mediocrity is not in your DNA",
  "Earn your body",
  "The gym is your battlefield",
  "Attack the day",
  "No days off from greatness",
  "You signed up for this. Now finish it",
];

export const getRandomQuote = (): string => {
  return MOTIVATIONAL_QUOTES[Math.floor(Math.random() * MOTIVATIONAL_QUOTES.length)];
};

interface ShareImageOptions {
  type: 'badge' | 'tier' | 'progress';
  userName: string;
  daysActive: number;
  tier: string;
  badge?: Badge;
  tierName?: string;
}

// Tier colors for canvas rendering
const TIER_COLORS: Record<string, { from: string; to: string }> = {
  RAW: { from: '#6B7280', to: '#374151' },
  FORGED: { from: '#D97706', to: '#92400E' },
  EVOLVED: { from: '#3B82F6', to: '#1D4ED8' },
  ASCENDED: { from: '#8B5CF6', to: '#6D28D9' },
  IMMORTAL: { from: '#EAB308', to: '#CA8A04' },
};

const BADGE_TIER_COLORS: Record<string, { from: string; to: string }> = {
  bronze: { from: '#B45309', to: '#78350F' },
  silver: { from: '#9CA3AF', to: '#6B7280' },
  gold: { from: '#EAB308', to: '#CA8A04' },
  platinum: { from: '#22D3EE', to: '#0891B2' },
  diamond: { from: '#60A5FA', to: '#A78BFA' },
  legendary: { from: '#A855F7', to: '#EC4899' },
};

export async function generateShareImage(options: ShareImageOptions): Promise<Blob> {
  const { type, userName, daysActive, tier, badge, tierName } = options;
  
  const canvas = document.createElement('canvas');
  canvas.width = 600;
  canvas.height = 600;
  const ctx = canvas.getContext('2d')!;
  
  // Background gradient (dark)
  const bgGradient = ctx.createLinearGradient(0, 0, 600, 600);
  bgGradient.addColorStop(0, '#0F0F0F');
  bgGradient.addColorStop(1, '#1A1A1A');
  ctx.fillStyle = bgGradient;
  ctx.fillRect(0, 0, 600, 600);
  
  // Add subtle grid pattern
  ctx.strokeStyle = 'rgba(255,255,255,0.03)';
  ctx.lineWidth = 1;
  for (let i = 0; i < 600; i += 30) {
    ctx.beginPath();
    ctx.moveTo(i, 0);
    ctx.lineTo(i, 600);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(0, i);
    ctx.lineTo(600, i);
    ctx.stroke();
  }
  
  // Evolve AI Coach Logo (top left)
  ctx.save();
  // Red accent circle
  ctx.fillStyle = '#EF4444';
  ctx.beginPath();
  ctx.arc(60, 50, 20, 0, Math.PI * 2);
  ctx.fill();
  
  // Logo text
  ctx.fillStyle = '#FFFFFF';
  ctx.font = 'bold 18px Inter, system-ui, sans-serif';
  ctx.fillText('EVOLVE', 90, 45);
  ctx.font = '14px Inter, system-ui, sans-serif';
  ctx.fillStyle = '#9CA3AF';
  ctx.fillText('AI COACH', 90, 62);
  ctx.restore();
  
  // Get tier colors
  let tierColors = TIER_COLORS[tier] || TIER_COLORS.RAW;
  if (type === 'badge' && badge) {
    tierColors = BADGE_TIER_COLORS[badge.tier] || BADGE_TIER_COLORS.bronze;
  }
  
  // Main icon/badge circle with glow
  const centerX = 300;
  const centerY = 200;
  const radius = 80;
  
  // Glow effect
  ctx.save();
  ctx.shadowColor = tierColors.from;
  ctx.shadowBlur = 40;
  const glowGradient = ctx.createRadialGradient(centerX, centerY, 0, centerX, centerY, radius);
  glowGradient.addColorStop(0, tierColors.from);
  glowGradient.addColorStop(1, tierColors.to);
  ctx.fillStyle = glowGradient;
  ctx.beginPath();
  ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
  
  // Icon emoji
  ctx.font = '64px Apple Color Emoji, Segoe UI Emoji, sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  if (type === 'badge' && badge) {
    ctx.fillText(badge.icon, centerX, centerY);
  } else if (type === 'tier') {
    const tierIcons: Record<string, string> = {
      RAW: '💀',
      FORGED: '🔥',
      EVOLVED: '⚡',
      ASCENDED: '👑',
      IMMORTAL: '🏆',
    };
    ctx.fillText(tierIcons[tier] || '🔥', centerX, centerY);
  } else {
    ctx.fillText('📸', centerX, centerY);
  }
  
  // Title
  ctx.fillStyle = '#FFFFFF';
  ctx.font = 'bold 32px Inter, system-ui, sans-serif';
  ctx.textAlign = 'center';
  if (type === 'badge' && badge) {
    ctx.fillText(badge.name, 300, 320);
  } else if (type === 'tier') {
    ctx.fillText(tierName || tier, 300, 320);
  } else {
    ctx.fillText('Progress Update', 300, 320);
  }
  
  // Tier badge
  const badgeTierGradient = ctx.createLinearGradient(220, 345, 380, 375);
  badgeTierGradient.addColorStop(0, tierColors.from);
  badgeTierGradient.addColorStop(1, tierColors.to);
  ctx.fillStyle = badgeTierGradient;
  roundRect(ctx, 240, 340, 120, 28, 14);
  ctx.fill();
  
  ctx.fillStyle = '#FFFFFF';
  ctx.font = 'bold 12px Inter, system-ui, sans-serif';
  ctx.fillText(type === 'badge' && badge ? badge.tier.toUpperCase() : tier, 300, 358);
  
  // User info
  ctx.fillStyle = '#FFFFFF';
  ctx.font = 'bold 24px Inter, system-ui, sans-serif';
  ctx.fillText(`Evolver ${userName}`, 300, 420);
  
  // Days info
  ctx.font = '18px Inter, system-ui, sans-serif';
  ctx.fillStyle = '#9CA3AF';
  ctx.fillText(`Day ${daysActive} — ${tier}`, 300, 450);
  
  // Random motivational quote
  const quote = getRandomQuote();
  ctx.fillStyle = '#6B7280';
  ctx.font = 'italic 14px Inter, system-ui, sans-serif';
  
  // Word wrap the quote
  const maxWidth = 500;
  const words = quote.split(' ');
  let line = '';
  let y = 500;
  
  for (const word of words) {
    const testLine = line + word + ' ';
    const metrics = ctx.measureText(testLine);
    if (metrics.width > maxWidth && line !== '') {
      ctx.fillText(`"${line.trim()}"`, 300, y);
      line = word + ' ';
      y += 20;
    } else {
      line = testLine;
    }
  }
  if (line) {
    ctx.fillText(`"${line.trim()}"`, 300, y);
  }
  
  // Bottom branding
  ctx.fillStyle = 'rgba(239, 68, 68, 0.8)';
  ctx.fillRect(0, 570, 600, 30);
  ctx.fillStyle = '#FFFFFF';
  ctx.font = 'bold 12px Inter, system-ui, sans-serif';
  ctx.fillText('evolveaicoach.app — First 500 get 40% off for life', 300, 588);
  
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob);
      } else {
        reject(new Error('Failed to create image blob'));
      }
    }, 'image/png');
  });
}

// Helper function for rounded rectangles
function roundRect(ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, radius: number) {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
}

export function getShareCaption(
  type: 'badge' | 'tier' | 'progress',
  userName: string,
  daysActive: number,
  tier: string,
  referralCode?: string,
  badge?: Badge
): string {
  const displayName = userName || 'Anonymous';
  const referralUrl = referralCode 
    ? `https://evolveaicoach.app/?ref=${referralCode}`
    : 'https://evolveaicoach.app';

  let achievement = '';
  if (type === 'badge' && badge) {
    achievement = badge.name.toUpperCase();
  } else if (type === 'tier') {
    achievement = tier;
  } else {
    achievement = 'a new milestone';
  }

  return `Just hit ${achievement} (Day ${daysActive}) on Evolve AI Coach! 🔥

My AI coach roasts my excuses and builds 100% custom plans.

Try it free (first 500 get lifetime 40% off):
${referralUrl}

#EvolveAICoach #FitnessJourney #${tier.replace(/\s+/g, '')}`;
}

export async function shareWithImage(
  imageBlob: Blob,
  caption: string,
  fileName: string = 'evolve-achievement.png'
): Promise<boolean> {
  // Try Web Share API first (mobile-friendly)
  if (navigator.share && navigator.canShare) {
    const file = new File([imageBlob], fileName, { type: 'image/png' });
    const shareData = {
      files: [file],
      text: caption,
    };

    if (navigator.canShare(shareData)) {
      try {
        await navigator.share(shareData);
        return true;
      } catch (err) {
        // User cancelled or share failed, fall through to fallback
        if ((err as Error).name === 'AbortError') {
          return false;
        }
      }
    }
  }

  // Fallback: Download image and copy caption
  return false;
}

export function downloadImage(blob: Blob, fileName: string = 'evolve-achievement.png') {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
